import { render, staticRenderFns } from "./ArticleComments.vue?vue&type=template&id=2019a55e&"
import script from "./ArticleComments.vue?vue&type=script&lang=js&"
export * from "./ArticleComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports